export default {
  title: {
    id: 'noNetworkMode.title',
    defaultMessage:
      'Internet connection lost. Please wait until your signal is back or restart the app.',
  },
};
